<template>
  <div class="c-requestAddConfirmButtons">
    <div class="c-requestAddConfirmButton c-requestAddConfirmButton-main">
      <c-button-v2
        color="primary"
        :size="mainButtonSize"
        width="100%"
        :disabled="isLoading"
        @click="submit"
      >
        依頼を投稿する
      </c-button-v2>
    </div>
    <div class="c-requestAddConfirmButton c-requestAddConfirmButton-sub">
      <c-button-v2
        color="thirdly"
        size="m"
        width="100%"
        @click="back"
      >
        依頼内容の修正
      </c-button-v2>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  name: 'RequestAddConfirmButtons',
  props: {
    isLoading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters('ui', ['isPC']),
    mainButtonSize() {
      if (this.isPC) {
        return 'l'
      }

      return 'm'
    }
  },
  methods: {
    submit() {
      this.$emit('submit')
    },
    back() {
      this.$emit('back')
    }
  }
}
</script>
<style lang="scss" scoped>
@media (max-width: breakpoint(Requests, M)) {
  .c-requestAddConfirmButtons {
    position: fixed;
    bottom: 0;
    z-index: z(fixed-footer);
    display: flex;
    flex-direction: row-reverse;
    padding: 12px;
    width: 100%;
    border-top: 1px solid $color-gray-50;
    background: $color-white;
  }

  .c-requestAddConfirmButton {
    &-sub {
      flex-shrink: 0;

      /deep/ .c-buttonV2 {
        padding: 0 1em;
        white-space: nowrap;
      }
    }

    &-main {
      flex: 1 1 100%;
      margin-left: 16px;
    }
  }
}

@media (min-width: breakpoint(Requests, M) + 1) {
  .c-requestAddConfirmButtons {
    position: sticky;
    top: 157px;
  }

  .c-requestAddConfirmButton {
    &-sub {
      margin-top: 16px;
      margin-bottom: 24px;
      padding-top: 16px;
      border-top: 1px solid $color-gray-200;
    }
  }
}
</style>
